module.exports = __webpack_public_path__ + "static/media/nashville-hot-chicken-sandwich-mobile-en.a6fea02f.jpg";